import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from '@nuxtjs/composition-api';
import { MetaInventoryContainer } from "~/core/models/MetaInventoryContainer";

interface Props {
    mobile?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BalanceSection',
  props: {
    mobile: { type: Boolean, default: false }
  },
  setup(__props: any) {

const {
    mobile,
} = __props as { mobile: boolean };

//////
//! Remove this wrapper and use components directly when data is available in store
//////
const inventoryContainerInstance = ref(MetaInventoryContainer.sharedInstance());

function isNumber(value: any): value is number {
    return typeof value === 'number';
}

const balances = computed(() => [
    {
        icon: {
            path: 'currency',
            name: 'usdt',
        },
        symbol: 'USDT',
        amount: inventoryContainerInstance.value
            .userCryptoBalance
            ?.usdt
            ?? null,
        skeleton: true,
        loading: !isNumber(inventoryContainerInstance.value.userCryptoBalance?.usdt),
    },
    {
        icon: {
            path: 'currency',
            name: 'gymnet',
        },
        symbol: 'GYMNET',
        amount: inventoryContainerInstance.value
            .userCryptoBalance
            ?.gymnet
            ?? null,
        skeleton: true,
        loading: !isNumber(inventoryContainerInstance.value.userCryptoBalance?.gymnet),
    },
    {
        icon: {
            path: 'currency',
            name: 'pap',
        },
        symbol: 'PAP',
        amount: inventoryContainerInstance.value
            .userCryptoBalance
            ?.subscriptionPoints
            ?? null,
        skeleton: true,
        loading: !isNumber(inventoryContainerInstance.value.userCryptoBalance?.subscriptionPoints),
    },
    {
        icon: {
            path: 'currency',
            name: 'utility',
        },
        symbol: 'Utility',
        amount: inventoryContainerInstance.value.minerRewardsData
            ?.minerRewards
            ?.minerRewardsUtilityInfo
            ?.realAvailable ?? null,
        skeleton: true,
        loading: !isNumber(inventoryContainerInstance.value.minerRewardsData?.minerRewards?.minerRewardsUtilityInfo?.realAvailable),
    },
]);



return { __sfc: true,inventoryContainerInstance, isNumber, balances, mobile }
}

})